/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
import { html, LitElement } from 'lit-element';
import '../../styles';
import { dispatchAttributeChangedEvent } from '../../utils/attribute-changed-event-dispatcher.js';
import switchStyles from './sh-switch.lit.scss.js';
// import { extendInteractiveArea } from '../../utils/interactive-area.js';

/**
 * @prop {Boolean} stretch - Default false. If set to `true`, the switch will occupy the entire width of it's container.
 * @prop {Boolean} disabled - Default false. If set to `true`, the switch will not allow any interaction.
 * @prop {Boolean} condensed - Default false. If set to `true`, the switch shows condensed styles. Applicable only for text-switches.
 */
export class SHSwitch extends LitElement {
  static get properties() {
    return {
      stretch: { type: Boolean, reflect: true },
      disabled: { type: Boolean, reflect: true },
      condensed: { type: Boolean, reflect: true },
    };
  }
  static get styles() {
    return [switchStyles];
  }
  render() {
    return html` <slot></slot> `;
  }
  updated(changedProperties) {
    if (changedProperties.has('disabled')) {
      this.handleDisabledChange();
    }
    if (changedProperties.has('condensed')) {
      this.handleCondensedChange();
    }
    const listOfProperties = ['stretch', 'disabled', 'condensed'];
    dispatchAttributeChangedEvent(this, changedProperties, listOfProperties);
  }
  handleDisabledChange() {
    const childrenItems = this.children;
    for (let i = 0; i < childrenItems.length; i++) {
      childrenItems[i].disabled = this.disabled;
    }
  }
  handleCondensedChange() {
    const switchItemHasIcon = this.querySelector('sh-switch-item[icon]:not([icon=""])');
    if (!switchItemHasIcon) {
      const switchItems = this.querySelectorAll('sh-switch-item');
      for (let i = 0; i < switchItems.length; i++) {
        switchItems[i].condensed = this.condensed;
      }
    }
    if (switchItemHasIcon && this.condensed) {
      console.warn(
        'Condensed style will not be applied to switch and condensed property will not be applied to switch-items , if any switch-item has icon'
      );
    }
  }
}

customElements.define('sh-switch', SHSwitch);
